import React from 'react';
import { ContainerFlex } from '../ContainerFlex/index.js';
import '../AsideMenu/index.js';
import '../AsideMenuMobile/index.js';
import '../BottomMenuMobile/index.js';
import '../Header/index.js';
import '../Logo/index.js';
import { ToolbarWrapper } from '../ToolbarWrapper/index.js';
import '../SearchWrapper/index.js';
import { useWindowSize } from '../../../../../../utils/hooks/useWindowSize.js';

const HeaderCenterWrapper = ({
  children
}) => {
  const { isMobile, isTablet } = useWindowSize();
  const View = isMobile || isTablet ? ContainerFlex : ToolbarWrapper;
  return /* @__PURE__ */ React.createElement(View, { size: "sm" }, children);
};
HeaderCenterWrapper.displayName = "HeaderCenterWrapper";

export { HeaderCenterWrapper };
//# sourceMappingURL=index.js.map
